module.exports = __webpack_public_path__ + "static/media/3.eafb17b8.png";